import Base from "../../base";
import SideMenu from "../SideMenu";
import LeftMenu from "../../../components/LeftMenu";
import Header from "../Header";
import { useParams } from "react-router";
import UsersForm from "./UserForm";

function UsersView() {
  const params = useParams();

  return (
    <Base>
      <Header />
      <div className="py-16 container m-auto px-6 grid grid-cols-12">
        <div className="col-span-12 lg:col-span-3 xl:col-span-2">
          <LeftMenu menu={SideMenu} />
        </div>
        <UsersForm userId={params.id} />
      </div>
    </Base>
  );
}

export default UsersView;
